import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface SignContractData {
  contractId: number;
  contractNo: string | null;
  customerName: string;
  provider?: boolean;   // true = provider counter-signature
}

@Component({
  selector: 'app-sign-contract-dialog',
  templateUrl: './sign-contract-dialog.component.html',
  styleUrls: ['./sign-contract-dialog.component.css'],
})
export class SignContractDialogComponent {
  signerName = '';
  signerEmail = '';
  agreed = false;
  signature: string | null = null;
  saving = false;
  error = '';

  constructor(
    private http: HttpClient,
    private dialogRef: MatDialogRef<SignContractDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SignContractData,
    private snackBar: MatSnackBar,
  ) {
    this.signerName = data.provider ? '' : (data.customerName ?? '');
  }

  onSignature(png: string | null): void { this.signature = png; }

  get canSign(): boolean {
    return !!this.signerName.trim() && !!this.signature && this.agreed && !this.saving;
  }

  submit(): void {
    if (!this.canSign) return;
    this.saving = true;
    this.error = '';
    const endpoint = this.data.provider ? 'sign-provider' : 'sign-inapp';
    this.http.post(`/api/contracts/${this.data.contractId}/${endpoint}`, {
      signerName: this.signerName.trim(),
      signerEmail: this.signerEmail.trim() || null,
      signatureImage: this.signature,
    }).subscribe({
      next: () => {
        this.saving = false;
        this.snackBar.open('Contract signed', undefined, { duration: 2500 });
        this.dialogRef.close(true);
      },
      error: (e: any) => { this.saving = false; this.error = e?.error?.error || 'Failed to sign.'; },
    });
  }

  cancel(): void { this.dialogRef.close(false); }
}
